import React from 'react';
import { formatMoney, formatNumber, formatDate } from '../../utils/formatters';

/* Иконки рисуем штрихом вместо эмодзи — см. Navbar.jsx, откуда взят паттерн. */
const Icon = ({ children }) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);
const CheckIcon = () => <Icon><circle cx="12" cy="12" r="10" /><path d="M8.5 12.5L10.5 14.5L15.5 9.5" /></Icon>;
const StopIcon = () => <Icon><circle cx="12" cy="12" r="10" /><path d="M5 19L19 5" /></Icon>;

/* Пока не подключён Cloud API у организации или он ответил ошибкой —
   отдельный кроткий статус, а не пустой список: молчание тут легко
   принять за «стоп-листа нет», хотя на деле просто не смогли спросить. */
const StopListPanel = ({ stopList }) => {
  if (!stopList?.available) {
    return (
      <div className="kt-panel">
        <div className="kt-empty">
          <StopIcon /> {stopList?.reason || 'Стоп-лист недоступен'}
        </div>
      </div>
    );
  }

  const items = stopList.items || [];
  const hiddenCount = stopList.hidden_count || 0;

  if (!items.length) {
    return (
      <div className="kt-panel">
        <div className="kt-empty">
          {hiddenCount > 0 ? (
            <>
              <StopIcon /> В стопе {formatNumber(hiddenCount)} позиций, но ни одна не продавалась
              за выбранный период — показывать по ним нечего.
            </>
          ) : (
            <><CheckIcon /> Стоп-лист пуст — ни одной позиции не остановлено</>
          )}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="kt-compare-grid">
        <div className="kt-compare-card">
          <div className="kt-compare-label">Позиций в стопе с продажами</div>
          <div className="kt-compare-value">{formatNumber(stopList.count)}</div>
          <div className="kt-compare-note">
            {hiddenCount > 0
              ? `ещё ${formatNumber(hiddenCount)} без продаж за период — не показаны`
              : 'все позиции стоп-листа продавались за период'}
          </div>
        </div>
        <div className="kt-compare-card">
          <div className="kt-compare-label">Упущенная выручка</div>
          <div className="kt-compare-value warn">{formatMoney(stopList.total_lost_estimate)}</div>
          <div className="kt-compare-note">оценка за выбранный период, по обычным продажам блюда</div>
        </div>
      </div>

      <div className="kt-panel">
        <h2><StopIcon /> Что сейчас в стопе</h2>
        <p className="kt-panel-hint">
          Упущенная выручка — средняя выручка блюда в день за выбранный период,
          умноженная на число дней простоя в этом же периоде. Позиции без
          продаж за период не показаны — по ним не на что опереться.
        </p>
        <div className="kt-table-wrap">
          <table className="kt-table">
            <thead>
              <tr>
                <th>Блюдо</th>
                <th>Группа</th>
                <th>В стопе с</th>
                <th className="num">Дней</th>
                <th className="num">Продажи за период</th>
                <th className="num">Упущено</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={`${item.sku}-${index}`}>
                  <td className="kt-table-name">{item.name}</td>
                  <td className="kt-dim">{item.group || '—'}</td>
                  <td className="kt-dim">{item.since ? formatDate(item.since) : '—'}</td>
                  <td className="num">{item.days_stopped ?? '—'}</td>
                  <td className="num">{formatMoney(item.revenue_period)}</td>
                  <td className={`num ${item.lost_estimate > 0 ? 'kt-text-danger' : ''}`}>
                    {formatMoney(item.lost_estimate)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default StopListPanel;
